import { getEchoparkDisclaimer, getEchoparkLogoPath, getIcoLogoPath } from 'site-modules/multi-offer/utils/offers';

export const BRANDS = {
  GENERIC: 'generic',
  KMX: 'kmx',
  CARGURUS: 'cargurus',
  CARVANA: 'carvana',
  ECHOPARK: 'echopark',
  AUTONATION: 'autonation',
  PEDDLE: 'peddle',
  CASHFORCARS: 'cashforcars',
  CARWISER: 'carwiser',
  ICO: 'ico',
  ICOMODULE: 'icomodule',
  /* Below comment out due to brands not really being supported, and can easily bring back if we need */
  // SHIFT: 'shift',
};

export const ECHOPARK_DEFAULT_LOGO = 'img/multi-offer/logos/echopark.svg';
/**
 * Cobranded logo with America's Auto Auction.
 */
export const ECHOPARK_AAA_LOGO = 'img/multi-offer/logos/echopark-aaa.svg';
export const ECHOPARK_AMERICAS_AUTO_AUCTION_STORES = [
  '2144', // EchoPark Buy Center KC in Americas Auto Auction
  '2143', // EchoPark Buy Center Chicago in Americas Auto Auction
  '2145', // EchoPark Buy Center Thousand Oaks in Auctions in Motion
  '2149', // EchoPark Buy Center Tampa Bay in Americas Auto Auction
  '2150', // EchoPark Buy Center VA Beach in Americas Auto Auction
];

export const BRAND_TYPES = {
  [BRANDS.GENERIC]: {
    disclaimer:
      "The offer is contingent on your providing accurate information on Edmunds.com. There will be an in-person verification of your vehicle and evaluation of other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive.",
  }, // This should catch all fallback if brand does not exist in BRAND_TYPES.
  [BRANDS.KMX]: {
    name: 'CarMax',
    logoPath: 'img/multi-offer/logos/carmax.svg',
    emailLogoPath: 'img/multi-offer/logos/carmax.png',
    blackLogoPath: 'img/multi-offer/logos/carmax-black.svg',
    logoHeightMultiplier: 0.1989375,
    get logoWidthMultiplier() {
      return 1.0 / this.logoHeightMultiplier;
    },
    logoAltText: 'CarMax Logo',
    disclaimer:
      "The offer from CarMax is contingent on your providing accurate information on Edmunds.com. CarMax will conduct an in-person verification of your vehicle and evaluate other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive from CarMax.",
  },
  [BRANDS.CARGURUS]: {
    name: 'CarGurus',
    logoPath: 'img/multi-offer/logos/cargurus.svg',
    emailLogoPath: 'img/multi-offer/logos/cargurus.png',
    blackLogoPath: 'img/multi-offer/logos/cargurus-black.svg',
    logoHeightMultiplier: 0.1581875,
    get logoWidthMultiplier() {
      return 1.0 / this.logoHeightMultiplier;
    },
    logoAltText: 'CarGurus Logo',
    disclaimer:
      "The online offer is contingent on your providing accurate information on Edmunds.com. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive from CarGurus.",
  },
  [BRANDS.CARVANA]: {
    name: 'Carvana',
    logoPath: 'img/multi-offer/logos/carvana.svg',
    emailLogoPath: 'img/multi-offer/logos/carvana.png',
    blackLogoPath: 'img/multi-offer/logos/carvana-black.svg',
    logoHeightMultiplier: 0.14275,
    get logoWidthMultiplier() {
      return 1.0 / this.logoHeightMultiplier;
    },
    logoAltText: 'Carvana Logo',
    disclaimer:
      "The online offer is contingent on your providing accurate information on Edmunds.com. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive from Carvana.",
  },
  [BRANDS.ECHOPARK]: {
    name: 'EchoPark',
    logoPath: getEchoparkLogoPath,
    emailLogoPath: 'img/multi-offer/logos/echopark.png',
    blackLogoPath: 'img/multi-offer/logos/echopark-black.svg',
    logoAltText: 'EchoPark Logo',
    disclaimerObscured: getEchoparkDisclaimer,
    disclaimer: getEchoparkDisclaimer,
  },
  [BRANDS.AUTONATION]: {
    name: 'AutoNation',
    logoPath: 'img/multi-offer/logos/autonation.svg',
    emailLogoPath: 'img/multi-offer/logos/autonation.png',
    blackLogoPath: 'img/multi-offer/logos/autonation-black.svg',
    logoHeightMultiplier: 0.205128,
    get logoWidthMultiplier() {
      return 1.0 / this.logoHeightMultiplier;
    },
    logoAltText: 'AutoNation Logo',
    disclaimerObscured:
      'This price is based on data from thousands of similar market transactions as well as the information you provided. The offer provider may modify or revoke this price if the information you provided is inaccurate or if there is a significant present or prospective change in the used vehicle market beyond the offer provider’s control. Other terms and restrictions apply.',
    disclaimer:
      'This price is based on data from thousands of similar market transactions as well as the information you provided. AutoNation may modify or revoke this price if the information you provided is inaccurate or if there is a significant present or prospective change in the used vehicle market beyond AutoNation’s control. Other terms and restrictions apply.',
  },
  [BRANDS.PEDDLE]: {
    name: 'Peddle',
    logoPath: 'img/multi-offer/logos/peddle.svg',
    emailLogoPath: 'img/multi-offer/logos/peddle.png',
    blackLogoPath: 'img/multi-offer/logos/peddle-black.svg',
    logoHeightMultiplier: 0.262069,
    get logoWidthMultiplier() {
      return 1.0 / this.logoHeightMultiplier;
    },
    logoAltText: 'Peddle Logo',
    disclaimer:
      'The offer is contingent on your providing accurate information on Edmunds.com. There will be an in-person verification of your vehicle and evaluation of other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle’s actual condition, use, and history may affect the offer you receive.',
  },
  [BRANDS.CASHFORCARS]: {
    name: 'CashForCars.com',
    logoPath: 'img/multi-offer/logos/cashforcars.svg',
    emailLogoPath: 'img/multi-offer/logos/cashforcars.png',
    blackLogoPath: 'img/multi-offer/logos/cashforcars-black.svg',
    logoHeightMultiplier: 0.1681818,
    get logoWidthMultiplier() {
      return 1.0 / this.logoHeightMultiplier;
    },
    logoAltText: 'CashForCars.com Logo',
    disclaimer:
      "The offer is contingent on your providing accurate information on Edmunds.com. There will be an in-person verification of your vehicle and evaluation of other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive.",
  },
  [BRANDS.CARWISER]: {
    name: 'Carwiser',
    logoPath: 'img/multi-offer/logos/carwiser.svg',
    logoHeightMultiplier: 0.196787,
    get logoWidthMultiplier() {
      return 1.0 / this.logoHeightMultiplier;
    },
    logoAltText: 'Carwiser Logo',
  },
  [BRANDS.ICO]: {
    logoPath: getIcoLogoPath,
    disclaimer: ({ dealerName }) =>
      `The offer from ${dealerName} is contingent on your providing accurate information on Edmunds.com. ${dealerName} will conduct an in-person verification of your vehicle and evaluate other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive from our partners.`,
    disclaimerObscured: `The offer is contingent on your providing accurate information on Edmunds.com. The offer provider will conduct an in-person verification of your vehicle and evaluate other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive from our partners.`,
  },
  [BRANDS.ICOMODULE]: {
    disclaimer: ({ dealerName }) =>
      `The offer from ${dealerName} is contingent on your providing accurate information on Edmunds.com. ${dealerName} will conduct an in-person verification of your vehicle and evaluate other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive from our partners.`,
  },
  /* Below comment out due to brands not really being supported, and can easily bring back if we need */
  // [BRANDS.SHIFT]: {
  //   name: 'Shift',
  //   logoPath: 'img/multi-offer/logos/shift.svg',
  //   emailLogoPath: 'img/multi-offer/logos/shift.png',
  //   blackLogoPath: 'img/multi-offer/logos/shift-black.svg',
  //   logoHeightMultiplier: null,
  //   get logoWidthMultiplier() {
  //     return 1.0 / this.logoHeightMultiplier;
  //   },
  //   logoAltText: 'Shift Logo',
  // },
};

/**
 * Contains the brands Edmunds is working with (i.e. is getting offers from) currently.
 *
 * @type {(string)[]}
 */
export const CURRENT_BRANDS = [BRANDS.KMX, BRANDS.AUTONATION, BRANDS.ECHOPARK, BRANDS.CASHFORCARS];

// This array is used to form a list of brands in the lead form disclaimer
export const CURRENT_OFFER_PROVIDERS = [
  BRAND_TYPES[BRANDS.KMX].name,
  BRAND_TYPES[BRANDS.ECHOPARK].name,
  BRAND_TYPES[BRANDS.AUTONATION].name,
  BRAND_TYPES[BRANDS.CASHFORCARS].name,
];

export const ICO_SOURCES = { MODS: 'MODS', API: 'API' };
